/* eslint-disable jsx-a11y/media-has-caption */
import dayjs from "dayjs";
import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_SOUND } from "@assets/svgs/ICON_SOUND.svg";
import { Button } from "@components/Button";
import { Icon } from "@components/Icon";
import { Text } from "@components/Text";
import { COLOR_GREEN, COLOR_WHITE } from "@static/COLORS";

const { REACT_APP_API_ENDPOINT } = process.env;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ContainerContent = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  justify-content: center;
  align-items: center;
`;

const ContainerAudio = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  aspect-ratio: 16/9;
  background: black;
`;

const SectionAction = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
`;

export const ImportAudio = ({
  item,
  campaignData,
  onHandleImportBlockMedias = () => undefined,
}) => {
  const path = `${REACT_APP_API_ENDPOINT}/${_.get(item, ["path"])}`;

  const onHandleImport = () => {
    const blockMedia = {
      type: "audio",
      is_use_media_in_project: true,
      media_id: _.get(item, ["id"]),
      duration: _.get(item, ["duration"]),
      repeat: _.get(item, ["repeat"], 1),
      start_date: dayjs(campaignData?.campaign_start_date).format("YYYY-MM-DD"),
      end_date: dayjs(campaignData?.campaign_end_date).format("YYYY-MM-DD"),
      attribute: { objectFit: "contain", path: _.get(item, ["path"]) },
    };
    onHandleImportBlockMedias({ item: blockMedia });
  };
  return (
    <Container>
      <ContainerContent>
        <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
          <ContainerAudio>
            <Icon isCursor width={16} height={16}>
              <ICON_SOUND stroke="white" />
            </Icon>
            {/* <audio controls type={_.get(item, ["type"])} src={path} /> */}
          </ContainerAudio>
          <div style={{ width: "calc(100% - 85px)" }}>
            <Text isEllipsis={true} lines={1}>
              {_.get(item, ["display_name"])}
            </Text>
          </div>
        </div>
        <SectionAction>
          <Button
            type="button"
            color={COLOR_GREEN}
            padding="2px 12px"
            onClick={() => onHandleImport()}
          >
            <Text fontSize={"12px"} fontWeight="600" color={COLOR_WHITE}>
              ADD
            </Text>
          </Button>
        </SectionAction>
      </ContainerContent>
    </Container>
  );
};
